/**
 * Custom Build Editorial — cart/quote baskets, lookbook, dual CTA, quote form
 */
(function () {
  const STORAGE_KEY = 'tt_cbe_baskets';
  const root = document.querySelector('[data-cbe-root]');
  if (!root) return;

  const buildHandle = root.dataset.buildHandle || 'build';
  const storageKey = STORAGE_KEY + ':' + buildHandle;

  const state = loadState();

  const els = {
    cartCount: root.querySelectorAll('[data-cbe-cart-count]'),
    quoteCount: root.querySelectorAll('[data-cbe-quote-count]'),
    cartList: root.querySelector('[data-cbe-cart-list]'),
    quoteList: root.querySelector('[data-cbe-quote-list]'),
    checkoutBtn: root.querySelectorAll('[data-cbe-checkout]'),
    quoteOpenBtns: root.querySelectorAll('[data-cbe-open-quote]'),
    drawer: root.querySelector('[data-cbe-drawer]'),
    drawerClose: root.querySelectorAll('[data-cbe-drawer-close]'),
    toast: root.querySelector('[data-cbe-toast]'),
    packageList: root.querySelector('[data-cbe-package-list]'),
    packageInput: root.querySelector('[data-cbe-package-input]'),
  };

  function loadState() {
    try {
      const raw = sessionStorage.getItem(storageKey);
      if (!raw) return { cart: [], quote: [] };
      const parsed = JSON.parse(raw);
      return {
        cart: Array.isArray(parsed.cart) ? parsed.cart : [],
        quote: Array.isArray(parsed.quote) ? parsed.quote : [],
      };
    } catch (e) {
      return { cart: [], quote: [] };
    }
  }

  function saveState() {
    sessionStorage.setItem(storageKey, JSON.stringify(state));
  }

  function productFromEl(el) {
    return {
      productId: el.dataset.productId,
      variantId: el.dataset.variantId,
      title: el.dataset.productTitle,
      vendor: el.dataset.productVendor || '',
      sku: el.dataset.productSku || '',
      handle: el.dataset.productHandle,
      url: el.dataset.productUrl,
      image: el.dataset.productImage || '',
      price: el.dataset.productPrice || '',
      quoteOnly: el.dataset.quoteOnly === 'true',
      available: el.dataset.available === 'true',
    };
  }

  function findIndex(list, variantId) {
    return list.findIndex(function (item) {
      return String(item.variantId) === String(variantId);
    });
  }

  function addToQuote(product, opts) {
    opts = opts || {};
    if (findIndex(state.quote, product.variantId) === -1) {
      state.quote.push(product);
      saveState();
      if (!opts.silent) {
        render();
        showToast('Added to quote: ' + product.title);
      }
      return true;
    }
    if (!opts.silent) showToast('Already in quote');
    return false;
  }

  function addToCartBasket(product, opts) {
    opts = opts || {};
    if (product.quoteOnly) {
      if (!opts.silent) showToast('This item is quote-only');
      return false;
    }
    if (!product.available) {
      if (!opts.silent) showToast('This item is sold out for direct checkout');
      return false;
    }
    if (findIndex(state.cart, product.variantId) === -1) {
      state.cart.push(product);
      saveState();
      if (!opts.silent) {
        render();
        showToast('Added to cart list: ' + product.title);
      }
      return true;
    }
    if (!opts.silent) showToast('Already in cart list');
    return false;
  }

  function addToBuild(product) {
    var addedCart = false;
    var addedQuote = false;

    if (product.quoteOnly) {
      addedQuote = addToQuote(product, { silent: true });
      render();
      if (addedQuote) showToast('Added to quote: ' + product.title);
      else showToast('Already in your build');
      return;
    }

    // Buyable: cart if available, always include in quote for fitment path
    if (product.available) {
      addedCart = addToCartBasket(product, { silent: true });
    }
    addedQuote = addToQuote(product, { silent: true });
    render();

    if (!addedCart && !addedQuote) {
      showToast('Already in your build');
      return;
    }

    if (addedCart && addedQuote) {
      showToast('Added to checkout & quote: ' + product.title);
    } else if (addedCart) {
      showToast('Added to checkout: ' + product.title);
    } else if (product.available === false) {
      showToast('Sold out — added to quote: ' + product.title);
    } else {
      showToast('Added to quote: ' + product.title);
    }
  }

  function removeFrom(listName, variantId) {
    state[listName] = state[listName].filter(function (item) {
      return String(item.variantId) !== String(variantId);
    });
    saveState();
    render();
  }

  function money(cents) {
    if (!cents && cents !== 0) return '';
    try {
      return (Number(cents) / 100).toLocaleString('en-AU', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD',
      });
    } catch (e) {
      return '$' + (Number(cents) / 100).toFixed(2);
    }
  }

  function renderList(container, items, listName) {
    if (!container) return;
    if (!items.length) {
      container.innerHTML = '<li class="cbe-bar__empty">Nothing selected yet</li>';
      return;
    }
    container.innerHTML = items
      .map(function (item) {
        var meta = item.quoteOnly ? '<span class="cbe-bar__tag">Quote only</span>' : '<span class="cbe-bar__price">' + money(item.price) + '</span>';
        return (
          '<li class="cbe-bar__item" data-variant-id="' +
          item.variantId +
          '">' +
          '<div class="cbe-bar__item-main">' +
          '<span class="cbe-bar__item-title">' +
          escapeHtml(item.title) +
          '</span>' +
          meta +
          '</div>' +
          '<button type="button" class="cbe-bar__remove" data-cbe-remove="' +
          listName +
          '" data-variant-id="' +
          item.variantId +
          '" aria-label="Remove">&times;</button>' +
          '</li>'
        );
      })
      .join('');
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderPackageSummary() {
    if (!els.packageList) return;
    if (!state.quote.length) {
      els.packageList.innerHTML =
        '<li class="cbe-quote__package-empty">No parts selected yet. Add items from the lookbook or parts list.</li>';
    } else {
      els.packageList.innerHTML = state.quote
        .map(function (item) {
          var sku = item.sku ? ' (' + escapeHtml(item.sku) + ')' : '';
          var tag = item.quoteOnly ? ' — quote only' : '';
          return '<li>' + escapeHtml(item.title) + sku + tag + '</li>';
        })
        .join('');
    }
    if (els.packageInput) {
      els.packageInput.value = state.quote
        .map(function (item) {
          return item.title + (item.sku ? ' [' + item.sku + ']' : '') + (item.quoteOnly ? ' (quote only)' : '');
        })
        .join('\n');
    }
  }

  function render() {
    els.cartCount.forEach(function (el) {
      el.textContent = String(state.cart.length);
    });
    els.quoteCount.forEach(function (el) {
      el.textContent = String(state.quote.length);
    });
    renderList(els.cartList, state.cart, 'cart');
    renderList(els.quoteList, state.quote, 'quote');
    renderPackageSummary();

    if (els.checkoutBtn && els.checkoutBtn.length) {
      var canCheckout = state.cart.length > 0;
      els.checkoutBtn.forEach(function (btn) {
        btn.disabled = !canCheckout;
        btn.classList.toggle('is-disabled', !canCheckout);
        btn.setAttribute('aria-disabled', canCheckout ? 'false' : 'true');
      });
    }

    root.classList.toggle('cbe--has-selections', state.cart.length + state.quote.length > 0);
    root.classList.toggle('cbe--has-cart', state.cart.length > 0);
    root.classList.toggle('cbe--has-quote', state.quote.length > 0);
  }

  function showToast(message) {
    if (!els.toast) return;
    els.toast.textContent = message;
    els.toast.classList.add('is-visible');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () {
      els.toast.classList.remove('is-visible');
    }, 2400);
  }

  function openDrawer() {
    if (!els.drawer) return;
    renderPackageSummary();
    els.drawer.hidden = false;
    document.documentElement.classList.add('cbe-drawer-open');
    var first = els.drawer.querySelector('input, button, select, textarea');
    if (first) first.focus();
  }

  function closeDrawer() {
    if (!els.drawer) return;
    els.drawer.hidden = true;
    document.documentElement.classList.remove('cbe-drawer-open');
  }

  // Product actions
  root.addEventListener('click', function (e) {
    var buildBtn = e.target.closest('[data-cbe-add-build]');
    var quoteBtn = e.target.closest('[data-cbe-add-quote]');
    var cartBtn = e.target.closest('[data-cbe-add-cart]');
    var removeBtn = e.target.closest('[data-cbe-remove]');
    var hotspot = e.target.closest('[data-cbe-hotspot-toggle]');

    if (hotspot) {
      e.preventDefault();
      var card = hotspot.closest('[data-cbe-hotspot]');
      var wasOpen = card.classList.contains('is-open');
      root.querySelectorAll('[data-cbe-hotspot].is-open').forEach(function (el) {
        el.classList.remove('is-open');
        el.classList.remove('cbe-hotspot--flip');
      });
      var storyPop = root.querySelector('[data-cbe-story-pop]');
      if (storyPop) {
        storyPop.hidden = true;
        storyPop.innerHTML = '';
      }
      if (!wasOpen) {
        var topPct = parseFloat(card.style.top) || 0;
        if (topPct > 55) card.classList.add('cbe-hotspot--flip');
        card.classList.add('is-open');
      }
      return;
    }

    if (buildBtn) {
      e.preventDefault();
      var bEl = buildBtn.closest('[data-cbe-product]');
      if (bEl) addToBuild(productFromEl(bEl));
      return;
    }

    if (quoteBtn) {
      e.preventDefault();
      var pEl = quoteBtn.closest('[data-cbe-product]');
      if (pEl) addToQuote(productFromEl(pEl));
      return;
    }

    if (cartBtn) {
      e.preventDefault();
      var cEl = cartBtn.closest('[data-cbe-product]');
      if (cEl) addToCartBasket(productFromEl(cEl));
      return;
    }

    if (removeBtn) {
      e.preventDefault();
      removeFrom(removeBtn.dataset.cbeRemove, removeBtn.dataset.variantId);
    }
  });

  // Close hotspots on outside click
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cbe-hotspot]')) {
      root.querySelectorAll('[data-cbe-hotspot].is-open').forEach(function (el) {
        el.classList.remove('is-open');
      });
    }
  });

  els.quoteOpenBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  });

  els.drawerClose.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      closeDrawer();
    });
  });

  if (els.drawer) {
    els.drawer.addEventListener('click', function (e) {
      if (e.target === els.drawer) closeDrawer();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Checkout selected buyable items
  if (els.checkoutBtn && els.checkoutBtn.length) {
    els.checkoutBtn.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var buyable = state.cart.filter(function (item) {
          return !item.quoteOnly && item.available;
        });
        if (!buyable.length) {
          showToast('No checkout-ready items selected');
          return;
        }
        els.checkoutBtn.forEach(function (b) {
          b.disabled = true;
          if (b.classList.contains('cbe-cta__btn')) {
            b.textContent = 'Adding…';
          }
        });

        var items = buyable.map(function (item) {
          return { id: Number(item.variantId), quantity: 1 };
        });

        var rootPath =
          (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart add failed');
            return res.json();
          })
          .then(function () {
            window.location.href = rootPath + 'cart';
          })
          .catch(function () {
            showToast('Couldn’t add items to cart. Please try again.');
            els.checkoutBtn.forEach(function (b) {
              b.disabled = false;
              if (b.classList.contains('cbe-cta__btn')) {
                b.textContent = b.dataset.label || 'Checkout selected parts';
              }
            });
            render();
          });
      });
    });
  }

  // Gallery view more + subnav + quote form + writeup popovers
  initGalleryMore(root);
  initSubnav(root);
  initQuoteForm(root);
  initStoryPopovers(root);

  render();

  function productHandleFromHref(href) {
    try {
      var url = new URL(href, window.location.origin);
      var parts = url.pathname.split('/').filter(Boolean);
      var idx = parts.lastIndexOf('products');
      if (idx === -1 || !parts[idx + 1]) return '';
      return decodeURIComponent(parts[idx + 1]).toLowerCase();
    } catch (e) {
      return '';
    }
  }

  function initStoryPopovers(scope) {
    var library = scope.querySelector('[data-cbe-popover-library]');
    if (!library) return;
    if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

    var pop = document.createElement('div');
    pop.className = 'cbe-story-pop';
    pop.setAttribute('hidden', '');
    pop.setAttribute('data-cbe-story-pop', '');
    scope.appendChild(pop);

    var hideTimer = null;

    function closePop() {
      clearTimeout(hideTimer);
      pop.hidden = true;
      pop.innerHTML = '';
    }

    function scheduleHide() {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(closePop, 160);
    }

    function positionPop(anchor) {
      var rect = anchor.getBoundingClientRect();
      var width = pop.offsetWidth || 300;
      var height = pop.offsetHeight || 220;
      var left = Math.min(Math.max(12, rect.left), window.innerWidth - width - 12);
      var top = rect.bottom + 8;
      if (top + height > window.innerHeight - 12) {
        top = Math.max(12, rect.top - height - 8);
      }
      pop.style.left = left + 'px';
      pop.style.top = top + 'px';
    }

    function openPop(anchor, source) {
      clearTimeout(hideTimer);
      scope.querySelectorAll('[data-cbe-hotspot].is-open').forEach(function (el) {
        el.classList.remove('is-open');
        el.classList.remove('cbe-hotspot--flip');
      });
      pop.innerHTML = source.innerHTML;
      pop.hidden = false;
      positionPop(anchor);
    }

    scope.querySelectorAll('.cbe-story__body a[href*="/products/"]').forEach(function (link) {
      var handle = productHandleFromHref(link.getAttribute('href') || '');
      if (!handle) return;
      var source = library.querySelector('[data-cbe-popover-card="' + handle + '"]');
      if (!source) return;
      link.classList.add('cbe-story__product-link');
      link.addEventListener('mouseenter', function () {
        openPop(link, source);
      });
      link.addEventListener('mouseleave', scheduleHide);
    });

    pop.addEventListener('mouseenter', function () {
      clearTimeout(hideTimer);
    });
    pop.addEventListener('mouseleave', scheduleHide);
    window.addEventListener('scroll', closePop, { passive: true });
  }

  function initGalleryMore(scope) {
    scope.querySelectorAll('[data-cbe-gallery-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = btn.closest('.cbe-acc__body');
        var gallery = body && body.querySelector('[data-cbe-gallery]');
        if (!gallery) return;
        var expanded = gallery.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.textContent = expanded ? 'View fewer photos' : 'View more photos';
      });
    });
  }

  function initSubnav(scope) {
    var nav = scope.querySelector('[data-cbe-subnav]');
    if (!nav) return;

    var links = Array.prototype.slice.call(nav.querySelectorAll('[data-cbe-subnav-link]'));
    links = links.filter(function (link) {
      var id = link.getAttribute('href');
      if (!id || id.charAt(0) !== '#') return false;
      var target = scope.querySelector(id) || document.querySelector(id);
      if (!target) {
        link.hidden = true;
        return false;
      }
      return true;
    });
    if (!links.length) {
      nav.hidden = true;
      return;
    }

    function setActive(href) {
      links.forEach(function (l) {
        l.classList.toggle('is-active', l.getAttribute('href') === href);
      });
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href');
        var target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        var details = target.closest('details');
        if (details && !details.open) details.open = true;
        if (target.tagName === 'DETAILS' && !target.open) target.open = true;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setActive(id);
        if (history.replaceState) history.replaceState(null, '', id);
      });
    });

    var sections = links
      .map(function (link) {
        var el = document.querySelector(link.getAttribute('href'));
        return el ? { href: link.getAttribute('href'), el: el } : null;
      })
      .filter(Boolean);

    if (!sections.length) return;

    function updateActiveFromScroll() {
      var headerOffset =
        (parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0) +
        (nav.offsetHeight || 48) +
        24;
      var best = sections[0];
      var bestDist = Infinity;
      sections.forEach(function (section) {
        var top = section.el.getBoundingClientRect().top - headerOffset;
        // Prefer the last section whose top has crossed the sticky offset
        if (top <= 8) {
          var dist = Math.abs(top);
          if (dist <= bestDist) {
            bestDist = dist;
            best = section;
          }
        }
      });
      if (best) setActive(best.href);
    }

    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          updateActiveFromScroll();
          ticking = false;
        });
      },
      { passive: true }
    );
    updateActiveFromScroll();
  }

  function initQuoteForm(scope) {
    var formWrap = scope.querySelector('[data-cbe-quote-form]');
    if (!formWrap) return;

    var form = formWrap.querySelector('#cbe-quote-form');
    var sections = formWrap.querySelectorAll('[data-cbe-step]');
    var stepLabels = formWrap.querySelectorAll('[data-cbe-quote-steps] .cbe-quote__step');
    var backBtn = formWrap.querySelector('[data-cbe-quote-back]');
    var nextBtn = formWrap.querySelector('[data-cbe-quote-next]');
    var submitBtn = formWrap.querySelector('[data-cbe-quote-submit]');
    var scheduleYes = formWrap.querySelector('[data-cbe-schedule-yes]');
    var scheduleNo = formWrap.querySelector('[data-cbe-schedule-no]');
    var calendar = formWrap.querySelector('[data-cbe-calendar]');
    var dateInput = formWrap.querySelector('[data-cbe-date]');
    var klaviyoCfg = {};

    try {
      var cfgEl = formWrap.querySelector('[data-cbe-klaviyo]');
      if (cfgEl) klaviyoCfg = JSON.parse(cfgEl.textContent);
    } catch (e) {}

    var current = 1;
    var total = sections.length;

    if (dateInput) {
      dateInput.min = new Date().toISOString().split('T')[0];
    }

    function showStep(step) {
      current = step;
      sections.forEach(function (s) {
        var n = Number(s.getAttribute('data-cbe-step'));
        s.hidden = n !== step;
      });
      stepLabels.forEach(function (label, i) {
        label.classList.toggle('cbe-quote__step--active', i + 1 === step);
      });
      if (backBtn) backBtn.hidden = step === 1;
      if (nextBtn) nextBtn.hidden = step === total;
      if (submitBtn) submitBtn.hidden = step !== total;
    }

    function validateStep(step) {
      var section = formWrap.querySelector('[data-cbe-step="' + step + '"]');
      if (!section) return true;
      var required = section.querySelectorAll('[required]');
      for (var i = 0; i < required.length; i++) {
        var field = required[i];
        if (field.type === 'radio') {
          var name = field.name;
          if (!section.querySelector('input[name="' + name + '"]:checked')) {
            field.focus();
            return false;
          }
        } else if (!field.value) {
          field.reportValidity();
          field.focus();
          return false;
        }
      }
      if (step === 3) {
        var radios = ['build_stage', 'primary_use', 'timeline'];
        for (var r = 0; r < radios.length; r++) {
          if (!section.querySelector('input[name="' + radios[r] + '"]:checked')) {
            showToast('Please complete all build detail options');
            return false;
          }
        }
      }
      if (step === 4 && scheduleYes && scheduleYes.checked) {
        var d = form.querySelector('[name="consultation_date"]');
        var t = form.querySelector('[name="consultation_time"]');
        if (!d.value || !t.value) {
          showToast('Please choose a consultation date and time');
          return false;
        }
      }
      return true;
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (!validateStep(current)) return;
        if (current < total) showStep(current + 1);
      });
    }
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (current > 1) showStep(current - 1);
      });
    }

    function syncSchedule() {
      if (!calendar) return;
      var on = scheduleYes && scheduleYes.checked;
      calendar.hidden = !on;
      if (submitBtn) {
        submitBtn.textContent = on ? 'Submit & book consultation' : 'Submit quote request';
      }
    }
    if (scheduleYes) scheduleYes.addEventListener('change', syncSchedule);
    if (scheduleNo) scheduleNo.addEventListener('change', syncSchedule);
    syncSchedule();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validateStep(current)) return;
      renderPackageSummary();

      var data = new FormData(form);
      if (els.packageInput && !data.get('package_selections')) {
        data.set('package_selections', els.packageInput.value);
      }

      if (!klaviyoCfg.publicKey || !klaviyoCfg.listId || klaviyoCfg.publicKey.indexOf('YOUR_') === 0) {
        showToast('Quote form is not configured yet (Klaviyo keys).');
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting…';

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: data.get('form_source') || 'Build Page Quote',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: data.get('email'),
                  first_name: (data.get('full_name') || '').split(' ')[0] || '',
                  last_name: (data.get('full_name') || '').split(' ').slice(1).join(' ') || '',
                  phone_number: data.get('phone'),
                  properties: {
                    Location: data.get('location'),
                    Contact_Method: data.get('contact_method'),
                    Vehicle_Status: data.get('vehicle_status'),
                    Vehicle_Brand: data.get('vehicle_brand'),
                    Vehicle_Model: data.get('vehicle_model'),
                    Vehicle_Year: data.get('vehicle_year'),
                    Build_Stage: data.get('build_stage'),
                    Primary_Use: data.get('primary_use'),
                    Preferred_Timeline: data.get('timeline'),
                    Questions_Comments: data.get('questions_comments'),
                    Schedule_Consultation: data.get('schedule_consultation'),
                    Consultation_Date: data.get('consultation_date') || '',
                    Consultation_Time: data.get('consultation_time') || '',
                    Form_Source: data.get('form_source') || 'Build Page Quote',
                    Build_Name: data.get('build_name') || '',
                    Build_URL: data.get('build_url') || '',
                    Package_Selections: data.get('package_selections') || '',
                  },
                },
              },
            },
          },
          relationships: {
            list: { data: { type: 'list', id: klaviyoCfg.listId } },
          },
        },
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + klaviyoCfg.publicKey, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2023-12-15',
        },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          if (res.status === 202 || res.status === 200 || res.status === 204) {
            var consult = '';
            if (data.get('schedule_consultation') === 'yes' && data.get('consultation_date')) {
              consult =
                '<p>Consultation preferred: <strong>' +
                escapeHtml(data.get('consultation_date')) +
                '</strong> at <strong>' +
                escapeHtml(data.get('consultation_time')) +
                '</strong>.</p>';
            }
            formWrap.innerHTML =
              '<div class="cbe-quote__success">' +
              '<h2>Thank you!</h2>' +
              '<p>Your quote request for <strong>' +
              escapeHtml(data.get('build_name') || 'this build') +
              '</strong> has been submitted.</p>' +
              consult +
              '<p>Our team will be in touch shortly.</p>' +
              '</div>';
            state.quote = [];
            saveState();
            render();
          } else {
            throw new Error(String(res.status));
          }
        })
        .catch(function () {
          alert(
            'There was an error submitting the form. Please try again or call us on ' +
              (klaviyoCfg.phone || '07 5500 0095') +
              '.'
          );
          submitBtn.disabled = false;
          syncSchedule();
        });
    });

    showStep(1);
  }
})();
